import React from "react";

const PartnersTopNew = ({ partnersTopData = [] }) => {

    if (!partnersTopData.length) return null;

    return (
        <section className="pt-20 mb-10 md:mb-20">

            <div className="container px-4 mx-auto">
                {partnersTopData.map(({partners_top_select: {partners_top_status, partners_top_item}}, groupIndex) => (
                    <div className={"toppartner-new-" + groupIndex} key={groupIndex}>
                        {/* Название */}
                        <h3 className="text-center sm:text-2xl text-[1.1em] uppercase mb-3">{partners_top_status}</h3>

                        {/* Лого */}
                        <div className="flex flex-col sm:flex-row justify-center items-center flex-wrap gap-6">
                            {partners_top_item.map(({acf: {p_url, p_thumbnail, p_logo_width}}, partnerIndex) => (
                                <a
                                    key={`${groupIndex}-${partnerIndex}`}
                                    href={p_url ? p_url : '/'}
                                    className={"text-center block p-2 toppartner-count-" + partnerIndex}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img
                                        src={p_thumbnail}
                                        alt={partners_top_status}
                                        className="inline-block object-contain"
                                    />
                                </a>
                            ))}
                        </div>
                    </div>
                ))}
            </div>

        </section>
    );
};

export default PartnersTopNew;